import { getToken } from '@/utils/auth'
import { Toast } from 'vant'
import { STORAGE_KEYS } from '@/constants/appIdentity'

/** 本项目客服 token 本地键（跨域客服页仍通过 ?token= 传递） */
export const SUPPORT_TOKEN_KEY = STORAGE_KEYS.supportToken

/**
 * 客服聊天页必须与 App 登录 API 同源（同一套 JWT / 同一库），
 * 否则消息会写到别的站点后台，本站客服系统看不到。
 */
function resolveSupportChatUrl() {
  const configured = (process.env.VUE_APP_SUPPORT_CHAT_URL || '').trim()
  if (configured) return configured

  const baseApi = (process.env.VUE_APP_BASE_API || '').trim().replace(/\/+$/, '')
  if (/^https?:\/\//i.test(baseApi)) {
    return `${baseApi}/user/support/chat-page/`
  }
  // 开发默认打本机 Django；生产未配置时用当前站点同源客服页
  if (process.env.NODE_ENV === 'development') {
    return 'http://127.0.0.1:8000/user/support/chat-page/'
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/user/support/chat-page/`
  }
  return '/user/support/chat-page/'
}

export const SUPPORT_CHAT_URL = resolveSupportChatUrl()

/**
 * 把 App 登录拿到的 access 写入客服约定 key。
 * 客服页据此请求：
 *   GET /user/support/conversation/
 *   Authorization: Bearer <access>
 * 有 JWT → 登录会话（显示手机号）；没有 → 客服侧会走匿名（显示「未注册用户」）
 */
export function syncSupportAccessToken(accessToken) {
  if (!accessToken) return
  try {
    localStorage.setItem(SUPPORT_TOKEN_KEY, accessToken)
  } catch (e) {
    // ignore
  }
}

export function clearSupportAccessToken() {
  try {
    localStorage.removeItem(SUPPORT_TOKEN_KEY)
  } catch (e) {
    // ignore
  }
}

/**
 * 拼接客服页地址。
 * 跨域时附加 ?token=，便于客服域 H5 写入本域的 support_user_access_token。
 */
export function buildSupportChatUrl(accessToken) {
  const base = SUPPORT_CHAT_URL.replace(/\/+$/, '') + '/'
  if (!accessToken) return base
  const join = base.indexOf('?') >= 0 ? '&' : '?'
  return base + join + 'token=' + encodeURIComponent(accessToken)
}

/**
 * 打开在线客服：
 * 1. 取 App 登录 access（打后台 API 登录拿到的 JWT）
 * 2. 写入 localStorage.support_user_access_token
 * 3. 打开与当前 API 同源的 /user/support/chat-page/
 *
 * 不要走 /user/support/anonymous/conversation/。
 * 不要打开第三方客服域名（会导致后台看不到消息）。
 */
export function openSupportChat(options = {}) {
  const accessToken = getToken()
  if (!accessToken) {
    if (options.allowAnonymous) {
      window.location.href = buildSupportChatUrl('')
      return true
    }
    const message = options.loginMessage || '请先登录后再联系客服'
    if (typeof options.onNeedLogin === 'function') {
      options.onNeedLogin(message)
    } else {
      Toast(message)
    }
    return false
  }

  syncSupportAccessToken(accessToken)

  const chatUrl = buildSupportChatUrl(accessToken)
  if (options.newWindow) {
    window.open(chatUrl, '_blank')
  } else {
    window.location.href = chatUrl
  }
  return true
}
